<div class="meo-message" [class.user-message]="turn().role === 'user'" [class.assistant-message]="turn().role === 'assistant'">
  <div class="bubble">
    @if (turn().attachmentMeta; as att) {
      <div class="bubble-attachment" [class.clickable]="att.storagePath" (click)="openAttachment()">
        @if (thumbnailUrl()) {
          <img [src]="thumbnailUrl()" class="bubble-thumb" alt="attachment" />
        } @else {
          <div class="bubble-file-icon">
            <app-svg name="attachment" height="14" width="14" [color]="ss.theme().color7"></app-svg>
          </div>
        }
        <div class="bubble-attachment-info">
          <span class="bubble-attachment-name">{{ att.fileName }}</span>
          @if (attachmentInfo()) {
            <span class="bubble-attachment-meta">{{ attachmentInfo() }}</span>
          }
        </div>
      </div>
    }
    @if (turn().role === 'assistant') {
      <span class="bubble-text" [innerHTML]="parsedText()"></span>
    } @else {
      <span class="bubble-text">{{ turn().text }}</span>
    }
  </div>
</div>
